import React from 'react';
import {GuideName} from "../../../../../../shared/js/core-components/DialogueCommonMessages";
import classnames from "classnames";
import {SummaryPageSubtitle, SummaryPageTitle} from "../../../../../../shared/js/core-components/ProductPageMessages";
import SurveyPagePathMessage from "../../../../../../shared/js/core-components/SurveyPagePathMessage";
import SummaryActionButtons from "../../../../../../shared/js/core-components/ContactShareButtons";
import {isSummaryPage} from "@ignitesales/neuro-application";
import {getBackgroundImgStyle, generateBackgroundImageUrl} from "../../../../../../shared/js/utils/themeHelper.mjs";
import {useThemeSettings} from "../../../../../../shared/js/hooks/useThemeSettings.mjs";

const componentClass = 'sidebar';

const getPatternStyle = (patternKey, patternColorKey) => {
    const [colorKey] = (patternColorKey || 'b-10').split('-');
    const colorToUse = colorKey === 'b' ? 'black' : 'white';
    const backgroundImageUrl = generateBackgroundImageUrl(patternKey, `/classpath/assets/images/bg-${patternKey || 'ignite'}--${colorToUse}.png`);
    const patternStyle = getBackgroundImgStyle(backgroundImageUrl);
    return {
        ...patternStyle,
        opacity: .1,
        color: colorToUse
    };
};

const Sidebar = ({ isProductsPage }) => {
    const { getGeneralThemeConfigs } = useThemeSettings();
    const { pattern, patternColor } = getGeneralThemeConfigs();
    const { textColor, ...patternStyle } = getPatternStyle(pattern, patternColor);
    const classes = classnames(componentClass, {
        'sidebar--summary': isProductsPage,
        'sidebar--darkText': textColor === 'black'
    });

    const summaryPageMessage = <div className="summary-title"><SummaryPageTitle tagName="h4" /><SummaryPageSubtitle /></div>;

    return <div className={classes}>
        <GuideName tagName='span' />
        <div className="pageMessage">
            { isProductsPage ? summaryPageMessage : <SurveyPagePathMessage className="sidebarTransitionContainer" /> }
        </div>
        { isProductsPage && <SummaryActionButtons hideContactButton={!isSummaryPage()} useFullWidthButtons={true} /> }
        <div className={`${componentClass}__patternContainer`}>
            <div className={`${componentClass}__patternBackground`} style={patternStyle} />
        </div>
    </div>;
};
Sidebar.propTypes = {};

export default Sidebar;
